export const defaultObjectProps = {
    fill: '#1565C0',
    opacity: 1,
    backgroundColor: null,
    strokeWidth: 0.05,
    stroke: '#000',
    shadow: {
        color: '#000',
        blur: 3,
        offsetX: -1,
        offsetY: 0,
    },
};
